import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import { Grid } from "@mui/material";
import Cards from "../card/Cards";
import { CollapsedContainer } from "../collapsed/CollapsedContainer";
// import { contactTabs } from "../../tabs/contactTabs";
import useAnalyticsApi from "../../../hooks/useAnalyticsApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setAnalyticsData,
} from "../../../store/Contact/analyticsSlice";
import { axiosFunction} from "../../commonFunctions"; 
import { v2ReactURL } from "../../../utils/constant";
import { Pagination, responseSchema, RowData } from "../../../pages/Contact/MainDataTable";
import { setContactPayloadData } from "../../../store/Contact/contactPayloadSlice";
import { getCheckData } from "../../../utils/functions/numberToWord";

interface ExpandedProps {
  tabView: string;
  setRows: (rows: RowData[]) => void;
  setPagination: (pagination: Pagination) => void;
  pageOption: string;
  setSearchValue: (value: string) => void;
  setLoadingData: (loading: boolean) => void;
  selectedBranch: number[];
  open: boolean[]
  setOpen: React.Dispatch<React.SetStateAction<boolean[]>>;
  refreshAnalytics?: boolean;
}

 interface tabData {
  title: string;
  value: number | string |undefined;
  isCurrency?: boolean;
  tooltipMessage: string;
  index: number;
  apiField?: string;
  clickable?: boolean;
  navUrl?: string;
}

const Expanded: React.FC<ExpandedProps> = ({
  tabView,
  setRows,
  setPagination,
  pageOption,
  setSearchValue,
  setLoadingData,
  selectedBranch,
  open,
  setOpen,
  refreshAnalytics
}) => {
  // const [open, setOpen] = useState(contactTabs.map(() => true));
  const [selectedCard, setSelectedCard] = useState<SelectedCard>({});
  const contactPayloadData = useSelector((state:any) => state.contactPayloadData);

  const dispatch = useDispatch();

  const contactType = tabView;

  const { fetchAnalyticsApi, analyticsData } = useAnalyticsApi();
  useEffect(() => {
    fetchAnalyticsApi(contactType);
  }, [contactType,refreshAnalytics]);

  useEffect(() => {
    setSelectedCard({});
  }, [contactType]);

  const toggleTab = (index:number) => {
    setOpen((prevOpen) => {
      const newOpenStates = [...prevOpen];
      newOpenStates[index] = !newOpenStates[index];
      return newOpenStates;
    });
  };
  type SelectedCard = { [key: string]: number | [] };

  const handleCardClick = async (data:tabData, index:number) => {
    setSearchValue("");
    const updatedCard = () => {
      const newSelectedCards : SelectedCard = { ...selectedCard };
      newSelectedCards[tabView] =
        index === newSelectedCards[tabView] ? [] : index;
      return newSelectedCards;
    };
    const updatedSelectedCardValue = updatedCard();
    setSelectedCard(updatedSelectedCardValue);
    const apiFieldObject = {
      newCustomerCount: 0,
      repeatCustomerCount: 0,
      notPurchasedLastSixMonths: 0,
      totalOutstandingCustomers: 0,
      totalPayableSupplier: 0,
      totalOrderValue: 0,
      totalTransporterOrderValue: 0,
    };
    if (data.apiField) {
      apiFieldObject[data.apiField as keyof typeof apiFieldObject] =
        index === updatedSelectedCardValue[tabView] ? 1 : 0;
    }
    dispatch(setAnalyticsData(apiFieldObject));
    setLoadingData(true);

    const {
      cityIds,
      status,
      isMobNoVerify,
      membershipIds,
      contactType: contactTypes,
      createdByIds,
      pincodes,
      contactIds,
    } = contactPayloadData;
    const payloadData = {
      searchValue: "",
      branchIds: selectedBranch,
      contactIds: contactIds,
      isMobNoVerify: isMobNoVerify,
      membershipIds: membershipIds,
      contactType: contactTypes,
      length: parseInt(pageOption),
      start: 0,
      draw: 1,
      createdByIds: createdByIds,
      cityIds: cityIds,
      pincodes: pincodes,
      status: status,
      ...apiFieldObject,
    };
    dispatch(setContactPayloadData(payloadData));
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/customdatatable`,
      "POST",
      payloadData
    );
    const validatedData = responseSchema.safeParse(res.data);
    if (res.status && validatedData.success) {
      const contactList = validatedData.data?.data?.map((col, index) => ({
        ...col,
        index: index + 1,
        checked: false,
      }));
      setLoadingData(false);
      setPagination(res.data.dataTableMetaDTO);
      setRows(contactList);
    } else {
      setLoadingData(false);
      console.error("API response validation failed:", validatedData.error);
    }
  };

  const customerData : tabData[] = [
    {
      title: "New",
      value: analyticsData?.newCustomerCount,
      tooltipMessage: "New Customer From Past 1 Month",
      index: 0,
      apiField: "newCustomerCount",
    },
    {
      title: "Repetitive",
      value: analyticsData?.repeatCustomerCount,
      tooltipMessage: "Customer Who Purchased More Than Twice In A Month.",
      index: 1,
      apiField: "repeatCustomerCount",
      clickable: true,
    },
    {
      title: "Lost",
      value: analyticsData?.lostCustomerCount,
      tooltipMessage: "No Purchase In A Month.",
      index: 2,
      apiField: "notPurchasedLastSixMonths",
      clickable: true,
    },
    {
      title: "Receivables",
      value: analyticsData?.receivablesCustomerCount,
      tooltipMessage: "Total Outstanding Of Customer",
      index: 3,
      clickable: true,
      navUrl : "/accountreport/ledgeroutstanding/customers?contactRedirection=1",
    },
    {
      title: "Avg Bill Value",
      value: getCheckData(analyticsData?.avgCustomerCount?.toString()||"0"), 
      isCurrency: true,
      index: 4,
      tooltipMessage: "Total bill value / Total bill count",
    },
  ];

  const supplierData : tabData[] = [
    {
      title: "Total Vendor",
      value: analyticsData?.supplierCount,
      tooltipMessage: "Total Supplier/Vendor",
      index: 0,
    },
    {
      title: "Total Payable",
      value:
        !isNaN(analyticsData?.supplierTotalPayableSum ?? NaN)
          ?  getCheckData(analyticsData?.supplierTotalPayableSum?.toString()||"0") 
          : 0,
      tooltipMessage: "Total Payable Of Supplier/Vendor",
      index: 1,
      isCurrency: true,
      clickable: true,
      navUrl : "/accountreport/ledgeroutstanding/suppliers?contactRedirection=1",
    },
    {
      title: "Total Order Value",
      value: getCheckData(analyticsData?.totalSupplierOrderValue?.toString()||"0"),
      isCurrency: true,
      tooltipMessage: "Total Order Value Of Current Year",
      index: 2,
    },
    {
      title: "Total Order Count",
      value: analyticsData?.sumOfTotalSupplierOrderCount,
      tooltipMessage: "Total Order Count Of Current Year",
      index: 3,
      apiField: "totalOrderValue",
      clickable: true,
    },
  ];

  const transportData : tabData[] = [
    {
      title: "Total Transporter",
      value: analyticsData?.totaltransportercount,
      tooltipMessage: "Total Transporter",
      index: 0,
    },
    {
      title: "Order Value Transported",
      value: getCheckData(analyticsData?.totaltransporterordervalue?.toString()||"0"),
      isCurrency: true,
      index: 1,
      tooltipMessage: "Total Value Of Product Transported",
      // value: analyticsData?.totaltransporterordervalue,
      // apiField: "totalTransporterOrderValue",
    },
    // {
    //   title: "Total Cost",
    //   value: "0",
    //   tooltipMessage: "Total Transportation Cost",
    //   index: 2,
    //   clickable: true,
    // },
  ];

  const tabsData =
    tabView === "customers"
      ? customerData
      : tabView === "suppliers"
      ? supplierData
      : transportData;

  const tabViewMenu =
    tabView === "customers" ? 0 : tabView === "suppliers" ? 1 : 2;
    // console.log("open[tabViewMenu]",open[tabViewMenu])

    useEffect(()=>{
      localStorage.setItem("tabViewMenu", String(open[tabViewMenu]) )
    },[tabView,open])
  return (
    <CollapsedContainer>
      <Card className="card-container"  style={{position : 'relative', borderRadius : '0'}}>
        <CardHeader
          className="card-header"
          style={{position : 'relative' , width : !open[tabViewMenu]  ? '100%' : '50px' , zIndex : 2,float:'right', paddingRight : !open[tabViewMenu]  ? "17px" :"17px" , height : !open[tabViewMenu]  ? "" :"100px" }}
          action={
            <div
              onClick={() => toggleTab(tabViewMenu)}
              className="analytics-container"
            >
              {!open[tabViewMenu] ? <span>View Analytics</span> : ""}
              <IconButton
                aria-label="expand"
                size="small"
                className="icon-button"
              >
                {open[tabViewMenu] ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </div>
          }
        ></CardHeader>

        <div className="collapse-content" style={{position : 'absolute', top:0,left:0,width:'100%',}}>
          <Collapse in={open[tabViewMenu]} timeout="auto" unmountOnExit>
            <CardContent sx={{ padding: '14px 2px 10px 2px !important' }}>
              <Grid
                container
                item
                lg={12}
                spacing={2}
                alignItems="center"
                className="collapseScroll"
              >
                {tabsData.map((data, index) => {
                  return (
                    <Grid item xs="auto" key={index} style={{padding : "14px 35px 0"}}  >
                      <Cards
                        tooltip={data.tooltipMessage || ""}
                        title={data.title}
                        value={data.value || 0}
                        isCurrency={data.isCurrency ?? false}
                        // index={data.index}
                        isSelected={selectedCard[tabView] === index}
                        onClick={
                          data.apiField
                            ? () => handleCardClick(data, index)
                            : data.navUrl && data.navUrl.length > 0 
                            ? () => {
                                     window.open(`${window.location.origin}${data.navUrl}`, '_blank');
                              }
                            : () => {}
                        }
                        clickable={data.clickable}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </CardContent>
          </Collapse>
        </div>
      </Card>
    </CollapsedContainer>
  );
};

export default Expanded;
